// Add custom JavasScript here
// --------------------------

!function($) {
  
  // Document ready
  $(document).ready(function() {

    $('.nav-primary').on('mouseover', 'li.nav-node', function(event) {
        var $dropDown = $('ul.nav-multi-column', this).first();
        var element = event.target;
        if ($dropDown.length > 0 && !element.closest('.nav-multi-column')) {
          var winWidth = $(window).width();
          var eleLeft = parseInt($dropDown.css('left'));
          var eleOuterWidth = $dropDown.outerWidth();
          var eleBounds = $dropDown[0].getBoundingClientRect();
          var eleMargin;
          
          if (eleOuterWidth > winWidth) {
            winWidth = eleOuterWidth;
          }
          
          eleMargin = (winWidth - eleOuterWidth) / 2;
          
          if (eleMargin != eleBounds.x) {
            var elePositionX = eleBounds.x - eleLeft;
            var offset = eleMargin - elePositionX;
            $dropDown.css('left', offset + 'px');
          }
          
          return event.stopPropagation();
        }
    });
    
  });

}(jQuery.noConflict());